import { Component } from '@angular/core';

@Component({
  selector: 'app-ai-adoption',
  templateUrl: './ai-adoption.component.html',
  styleUrls: ['./ai-adoption.component.scss']
})
export class AiAdoptionComponent {

}
